import { actionTypes } from './actions';

import initialState from './initialState';

export default function lkIpReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_INFO:
      return state.set('loading', true).set('data', null);
    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', action.payload).set('error', false);
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload).set('data', null);
    default:
      return state;
  }
}
